import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export const allowedVariants = ['default', 'accordion'] as const;
type Variant = typeof allowedVariants[number];

export const makeExpandablePanelsProps = propsFactory(
  {
    /**
     * Вариант отображения
     * @values default, accordion
     * @default default
     */
    variant: {
      type: String as PropType<Variant>,
      default: 'default',
      validator: (v: any) => allowedVariants.includes(v)
    }
  },
  'CdsExpandablePanels'
);
